import { useGLTF, RoundedBox, Text } from "@react-three/drei";
import { RigidBody } from "@react-three/rapier";
import { COLORS } from "../../constants/colors";
import PointerShadow from "../pointers/PointerShadow.jsx";
import { MODELS } from "../loader/models.js";

const Dumbbell = ({ position = [0, 0, 0] }) => {
  const { scene } = useGLTF(MODELS.DUMBBELL);

  return (
    <group position={position}>
      <Text
        fontSize={0.9}
        color={"white"}
        rotation-x={-Math.PI / 2}
        position={[12, -0.99, -3]}
      >
        #SometimesGymVisitor
      </Text>
      <primitive scale={0.5} position-y={1} object={scene} />
      <PointerShadow width={14} height={11} opacity={0.5} softness={0.8} />
      <RigidBody type="fixed" colliders="cuboid" ccd={false}>
        <RoundedBox args={[5, 1, 3]} radius={0.01} position-y={-0.99}>
          <meshStandardMaterial color={COLORS.surfaceElements} />
        </RoundedBox>
      </RigidBody>
    </group>
  );
};

export default Dumbbell;
